import { render, staticRenderFns } from "./publiccase-manage-handled.vue?vue&type=template&id=4bd6f880&scoped=true"
import script from "./publiccase-manage-handled.vue?vue&type=script&lang=ts"
export * from "./publiccase-manage-handled.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd6f880",
  null
  
)

export default component.exports